import { createContext, useContext } from 'react';

/**
 * Controls for the Configuration Settings inline sidebar, owned by
 * `ConfigurationSettingsLayout` and offered to the pages it renders through the
 * `Outlet`.
 *
 * Exists because a page cannot reach its own layout's chrome any other way: the
 * sidebar is an ancestor, so a page that wants the extra width (the table
 * browser, when its Ask AI dock opens) has to publish that intent upward rather
 * than render it itself.
 */
export interface SettingsChromeControls {
  isSidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

/** Wrap the configuration `Outlet` in a provider to let its pages collapse the sidebar. */
export const SettingsChromeCtx = createContext<SettingsChromeControls | null>(null);

/**
 * Reads the ambient sidebar controls.
 *
 * Returns `null` when no provider is present — mirroring `useCompareView` — so a
 * page rendered outside this layout keeps working and simply cannot collapse
 * anything, rather than throwing.
 */
export function useSettingsChrome(): SettingsChromeControls | null {
  return useContext(SettingsChromeCtx);
}
